import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './example';
import Admin from './admin';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

const isAdmin = window.location.pathname.replace(/\/+$/, '') === '/admin';
const Page = isAdmin ? Admin : App;

createRoot(container).render(
  <StrictMode>
    <Page />
  </StrictMode>,
);
